export default "__VITE_ASSET__CpWGiE4Q__"